module.exports = __webpack_public_path__ + "static/media/cappslogo.50497793.png";